import { set } from 'lodash';
import { MaterialDesignSvg } from '../MaterialDesign/MaterialDesignSvg';

export class ThumbsUpDownRater extends HTMLElement {


    rating_prompt = 'Do you agree with this report?';
    helpful_prompt = 'Please tell us why you felt that this report was helpful?';

    maketing_label = 'We greatly appreciate your comments.<br/>  Please let us know if we can use your feedback in any of our marketing   content.';

    message_label = 'Please type your feedback here';

    disagree_prompt = '<span class="mandatory-star">*</span> Please tell us why you disagree with this report, which will be shared with our team of radiologists.';

    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.createComponents();
        this.loadEventHandlers();
    }

    createComponents() {
        if (this.dataset.prompt !== 'false') {
            const textDiv = document.createElement('div');
            textDiv.classList.add('rating-prompt');
            textDiv.innerHTML = this.rating_prompt;
            this.appendChild(textDiv);
        }
        this.createThumbs();
    }

    createThumbs() {
        const thumbsDiv = document.createElement('div');
        thumbsDiv.classList.add('thumbs-container');
        this.appendChild(thumbsDiv);

        // thumbs up button
        const thumbsUpBtn = document.createElement('a');
        thumbsUpBtn.classList.add('thumb-btn', 'thumb-up');
        thumbsUpBtn.setAttribute('tabindex', '-1');
        const thumbsUpSvg = this.createThumbSvg('thumb_up');
        thumbsUpBtn.appendChild(thumbsUpSvg);
        thumbsDiv.appendChild(thumbsUpBtn);

        // thumbs down button
        const thumbsDownBtn = document.createElement('a');
        thumbsDownBtn.classList.add('thumb-btn', 'thumb-down');
        thumbsDownBtn.setAttribute('tabindex', '-1');
        const thumbsDownSvg = this.createThumbSvg('thumb_down');
        thumbsDownBtn.appendChild(thumbsDownSvg);
        thumbsDiv.appendChild(thumbsDownBtn);
    }


    createThumbSvg(type) {
        const svg = document.createElement('material-design-svg');
        svg.classList.add('thumb-svg', 'thumb-up');
        svg.setAttribute('data-icon', `filled__${type}`);
        svg.classList.add(type);
        svg.dataset.iconSize = '24';
        return svg;
    }

    loadEventHandlers() {
        const ratingBtns = this.querySelectorAll('.thumb-btn');
        ratingBtns.forEach(btn => {
            btn.addEventListener('click', this.onThumbClick.bind(this));
        });

    }

    onThumbClick(event) {
        const btnType = event.currentTarget.classList.contains('thumb-up') ? 'up' : 'down';
        const ratingDlg = this.createRatingDialog(btnType);
        this.appendChild(ratingDlg);
        ratingDlg.showModal();
        ratingDlg.style.height = '650px';
        ratingDlg.style.opacity = '1';
        ratingDlg.style.width = '750px';

        setTimeout(() => {
            document.addEventListener('click', (event) => {
                if (!event.target.contains(ratingDlg)) {
                    return;
                }

                this.closeDialog(ratingDlg);
            });
        }, 100);

    }

    closeDialog(ratingDlg) {
        ratingDlg.addEventListener('transitionend', () => {
            ratingDlg.close();
            ratingDlg.remove();
        });

        ratingDlg.style.height = '0';
        ratingDlg.style.opacity = '0';
        ratingDlg.style.width = '0';
    }

    createRatingDialog(rating) {
        const ratingDlg = document.createElement('dialog');
        ratingDlg.classList.add('rating-dialog', 'thumbs-' + rating);
        if (rating === 'up') {
            const helpfulPrompt = document.createElement('div');
            helpfulPrompt.classList.add('helpful-prompt');
            helpfulPrompt.innerHTML = this.helpful_prompt;
            ratingDlg.appendChild(helpfulPrompt);
        }

        const reportedByDiv = this.createReportedByDiv();
        ratingDlg.appendChild(reportedByDiv);

        const ReportHeader = this.createReportHeader();
        ratingDlg.appendChild(ReportHeader);

        const marketingAcceptanceDiv = this.createMarketingAcceptanceDiv();
        ratingDlg.appendChild(marketingAcceptanceDiv);

        if (rating === 'down') {
            const disagreePrompt = document.createElement('div');
            disagreePrompt.classList.add('disagree-prompt');
            disagreePrompt.innerHTML = this.disagree_prompt;
            ratingDlg.appendChild(disagreePrompt);

            const requiredLabel = document.createElement('label');
            requiredLabel.classList.add('required-label');
            requiredLabel.innerHTML = 'Required';
            ratingDlg.appendChild(requiredLabel);
        }

        const messageDiv = this.createMessageDiv(rating);
        ratingDlg.appendChild(messageDiv);

        const sendBtn = this.createSendButton();
        ratingDlg.appendChild(sendBtn);


        return ratingDlg;
    }

    createSendButton() {
        const sendBtnContainer = document.createElement('div');
        sendBtnContainer.classList.add('send-btn-container');

        const sendBtn = document.createElement('button');
        sendBtn.classList.add('send-btn');
        sendBtn.innerHTML = 'Send';
        sendBtnContainer.appendChild(sendBtn);
        sendBtn.addEventListener('click', this.onSendClick.bind(this));
        return sendBtnContainer;
    }

    onSendClick(event) {
        const ratingDlg = event.currentTarget.closest('.rating-dialog');
        const reportedBy = ratingDlg.querySelector('.reported-by').value;
        const marketingAcceptanceChecked = ratingDlg.querySelector('input[name="marketing-acceptance"]:checked');
        const marketingAgree = marketingAcceptanceChecked ? marketingAcceptanceChecked.value : '';
        const description = ratingDlg.querySelector('.message-text').value;
        const rating = ratingDlg.classList.contains('thumbs-up');

        if (description === '') {
            toastr.error('Pease enter a description', 'Missing Info');
            const descrElem = this.querySelector('textarea.message-text');
            descrElem.focus();
            return;
        }

        if (reportedBy === "") {
            toastr.error('Please enter your name', 'Missing Info');
            const reportedByElem = this.querySelector('input.reported-by');
            reportedByElem.focus();
            return;
        }

        this.sendResults(reportedBy, marketingAgree, description, rating);

    }

    sendResults(reportedBy, market_agree, description, rating) {
        // get the report type 
        const reportType = this.dataset.report_type;
        // send results to server
        const formData = new FormData();
        formData.append('reported_by', reportedBy);
        formData.append('marketing_agree', market_agree);
        formData.append('description', description);
        formData.append('like', rating);
        if (reportType == 'rad') {
            formData.append('report_id', this.dataset.report_id);
        } else {
            formData.append('case_id', this.dataset.case_id);
            formData.append('ai_screening_eval_type_id', this.dataset.ai_screening_eval_type_id);
        }
        fetch('/api/' + reportType + '-report-feedback', {
            method: 'POST',
            Accept: 'application/json',
            body: formData
        }).then(response => {
            if (response.ok) {
                toastr.success('Thank you for your feedback', 'Feedback Sent');
                const ratingDlg = document.querySelector('.rating-dialog');
                this.closeDialog(ratingDlg);
            } else {
                // get error messages
                response.json().then(data => {
                    let errors = '';
                    for (const key in data.errors) {
                        errors += data.errors[key] + '\n';
                    }
                    toastr.error(errors, 'Error sending feedback');
                });
            }
        });



    }

    createMessageDiv(rating) {

        const messageFieldset = document.createElement('fieldset');
        messageFieldset.classList.add('message-fieldset', 'floating-label', 'thumbs-' + rating);

        // add input
        const messageInput = document.createElement('textarea');
        messageInput.setAttribute('required', 'required');
        messageInput.classList.add('message-text');
        messageFieldset.appendChild(messageInput);

        // add label
        const messageLabel = document.createElement('label');
        messageLabel.classList.add('message-label');
        messageLabel.innerHTML = this.message_label;
        messageLabel.setAttribute('for', 'message');
        messageFieldset.appendChild(messageLabel);

        return messageFieldset;
    }

    createMarketingAcceptanceDiv() {
        const marketingAcceptance = document.createElement('div');
        marketingAcceptance.classList.add('marketing-acceptance');
        const marketingLabel = document.createElement('label');
        marketingLabel.innerHTML = this.maketing_label;
        marketingLabel.classList.add('marketing-label');
        marketingAcceptance.appendChild(marketingLabel);
        const radiosDiv = document.createElement('div');
        radiosDiv.classList.add('radios-group');

        const yesGroup = document.createElement('div');
        yesGroup.classList.add('radio-group');
        const yesRadio = document.createElement('input');
        yesRadio.setAttribute('type', 'radio');
        yesRadio.setAttribute('name', 'marketing-acceptance');
        yesRadio.setAttribute('value', 'yes');
        yesGroup.appendChild(yesRadio);
        const yesLabel = document.createElement('label');
        yesLabel.innerHTML = 'Yes';
        yesGroup.appendChild(yesLabel);
        radiosDiv.appendChild(yesGroup);

        const noGroup = document.createElement('div');
        noGroup.classList.add('radio-group');
        const noRadio = document.createElement('input');
        noRadio.setAttribute('type', 'radio');
        noRadio.setAttribute('name', 'marketing-acceptance');
        noRadio.setAttribute('value', 'no');
        noGroup.appendChild(noRadio);
        const noLabel = document.createElement('label');
        noLabel.innerHTML = 'No';
        noGroup.appendChild(noLabel);
        radiosDiv.appendChild(noGroup);

        marketingAcceptance.appendChild(radiosDiv);
        return marketingAcceptance;
    }

    createReportedByDiv() {
        const reportedByDiv = document.createElement('div');
        reportedByDiv.classList.add('floating-label');
        const reportedByInput = document.createElement('input');
        reportedByInput.setAttribute('type', 'text');
        reportedByInput.setAttribute('required', 'required');
        reportedByInput.classList.add('reported-by');
        reportedByDiv.appendChild(reportedByInput);
        const reportedByLabel = document.createElement('label');
        reportedByLabel.innerHTML = 'Reported By';
        reportedByLabel.setAttribute('for', 'reported-by');
        reportedByDiv.appendChild(reportedByLabel);
        return reportedByDiv;
    }

    createReportHeader() {
        const ReportHeader = document.createElement('div');
        ReportHeader.classList.add('report-header');
        const ReportTitle = document.createElement('h3');
        ReportTitle.innerHTML = this.dataset.report_title; 
        ReportHeader.appendChild(ReportTitle);
        return ReportHeader;
    }

}

customElements.define('thumbs-up-down-rater', ThumbsUpDownRater);